/* eslint-disable no-param-reassign */

import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';

import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import createPersistedState from 'vuex-persistedstate';

import database from './orm/database';

import * as getters from './getters';
import { state, mutations, actions } from './mutations';

import meta from './modules/Meta';
import general from './modules/General';
import habit from './modules/Habit';

Vue.use(Vuex);

VuexORM.use(VuexORMAxios, {
  database,
  http: {
    baseURL: (process.env.NODE_ENV === 'development' && !process.env.CORDOVA_PLATFORM)
      ? 'https://api-habit-tracker.claudiacanu.dev' : 'https://api-habit-tracker.claudiacanu.com',
    url: '/',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    access_token() {
      if (Vue.auth.check()) {
        return Vue.auth.token();
      }
      return '';
    },
  },
});

const vuePersist = {
  key: 'habituals',
  paths: [
    'entities.form.data',
    // 'log.logs',
  ],
};

const store = new Vuex.Store({
  plugins: [
    pathify.plugin,
    VuexORM.install(database),
    createPersistedState(vuePersist),
  ],

  state,
  mutations,
  actions,
  getters,

  modules: {
    habit,
    general,
    meta,
  },
});

export default store;


// export default new Vuex.Store({
//   plugins: [
//     createPersistedState({
//       key: 'habituals',
//       paths: [
//         // 'entities.video.data',
//         // 'entities.channel.data',
//         // 'entities.player.data',
//         // 'entities.tag.data',
//         // 'log.logs',
//       ],
//     }),
//   ],
// state: {
//   _id: 0,
//   habbits: [],
// },
// mutations: {
//   add(state, name) {
//     const today = datetime.getTodaysDate();
//     state.habbits.push({
//       id: state._id,
//       name,
//       startedOn: today,
//       lastDone: '1970-01-01',
//       done: 0,
//       dones: {},
//     });
//     state._id += 1;
//   },
//   tick(state, id) {
//     const index = _.findIndex(state.habbits, val => val.id === id);
//     const today = datetime.getTodaysDate();
//     const found = state.habbits[index];
//     Vue.set(state.habbits, index, Object.assign(found, {
//       lastDone: today,
//       lastDoneTS: Date.now(),
//       dones: Object.assign({
//       }, found.dones, {
//         [today]: true,
//       }),
//       done: found.done + 1,
//     }));
//   },

//   untick(state, id) {
//     const index = _.findIndex(state.habbits, val => val.id === id);
//     const today = datetime.getTodaysDate();
//     const found = state.habbits[index];
//     const newDones = Object.assign({}, found.dones, {
//       [today]: false,
//     });
//     const allDays = Object.keys(newDones).filter(k => newDones[k]);
//     const lastDone = allDays.sort().reverse()[0] || '1970-01-01';
//     Vue.set(state.habbits, index, Object.assign(found, {
//       lastDone,
//       lastDoneTS: moment(lastDone).valueOf(),
//       dones: newDones,
//       done: found.done - 1,
//     }));
//   },

//   remove(state, id) {
//     console.log('Deleting', id);
//     state.habbits = state.habbits.filter(val => val.id !== id);
//   },
// },
// });


// import Vue from 'vue';
// import Vuex from 'vuex';

// import createPersistedState from 'vuex-persistedstate';

// import * as getters from './getters';
// import { state, mutations, actions } from './mutations';

// import admin from './modules/Admin';
// import search from './modules/Search';
// import category from './modules/Category';
// import game from './modules/Game';
// import league from './modules/League';
// import division from './modules/Division';
// import following from './modules/Following';
// import nav from './modules/Nav';
// import navigation from './modules/Navigation';
// import region from './modules/Region';
// import season from './modules/Season';
// import supervisor from './modules/Supervisor';
// import team from './modules/Team';
// import topics from './modules/Topics';
// import tournament from './modules/Tournament';
// import general from './modules/General';
// import meta from './modules/Meta';

// Vue.use(Vuex);

// // import * as actions from './actions';
// // import * as mutations from './mutations';

// const requestIdleCallback =
//   window.requestIdleCallback ||
//   ((cb) => {
//     const start = Date.now();
//     return setTimeout(() => {
//       const data = {
//         didTimeout: false,
//         timeRemaining() {
//           return Math.max(0, 50 - (Date.now() - start));
//         },
//       };
//       cb(data);
//     }, 1);
//   });

// const vuePersist = {
//   reducer: state => ({
//     nav: state.nav,
//     topics: state.topics,
//     lang: state.lang,
//   }),
//   saveState: (key, state, storage) => {
//     requestIdleCallback(() => {
//       storage.setItem(key, JSON.stringify(state));
//     });
//   },
// };

// const store = new Vuex.Store({
//   plugins: [createPersistedState(vuePersist)],

//   state,
//   mutations,
//   actions,
//   getters,

//   modules: {
//     admin,
//     search,
//     category,
//     game,
//     league,
//     division,
//     following,
//     nav,
//     navigation,
//     region,
//     season,
//     supervisor,
//     team,
//     topics,
//     tournament,
//     general,
//     meta,
//   },
// });

// export default store;
